import { gql } from '@apollo/client';

export const PUT_OBJECT_PRE_SIGNED_URL = gql`
  query putObjectPreSignedUrl(
    $entity: String!
    $fileName: String!
    $fileSize: Int!
    $isPublic: Boolean
  ) {
    putObjectPreSignedUrl(
      entity: $entity
      fileName: $fileName
      fileSize: $fileSize
      isPublic: $isPublic
    ) {
      url,
      publicUrl
    }
  }
`;

export const GET_OBJECT_PRE_SIGNED_URL = gql`
  query getObjectPreSignedUrl($id: Int!, $realName: String, $thumbnailType: String) {
    getObjectPreSignedUrl(id: $id, realName: $realName, thumbnailType: $thumbnailType) {
      url
      uploadedAt
    }
  }
`;

export const GET_ATTACHMENT_ID = gql`
  mutation persistAttachment($entity: String!, $fileName: String!) {
    persistAttachment(entity: $entity, fileName: $fileName) {
      id
    }
  }
`;

export const CONVERT_ATTACHMENT_TO_PDF = gql`
  mutation convertAttachmentToPDF(
    $id: Int!
  ) {
    convertAttachmentToPDF(
      id: $id
    ) {
        id
        size
    }
  }
`;
